<template>
  <b-card>
    <FormBuilder
      label="Pertanyaan"
      create
      :fields="fields"
      :loading-submit="$store.state.question.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/question'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('question/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
